import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RaidlyLanding from './pages/home';
import Success from './pages/success';
const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RaidlyLanding />} />
        <Route path="/success" element={<Success />} />
      </Routes>
    </Router>
  );
};

export default App
